import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../style/Fournisseur.css";
import { useParams } from "react-router-dom";
import axios from "axios";
import NotesFournisseur from "./NotesFournisseur.jsx";
import { useHistory } from "react-router-dom";
import SunEditor from "suneditor-react";
import { logOut } from "../../utils/login";
import "suneditor/dist/css/suneditor.min.css";
import Representant from "./Representant";
import ModalAvertissement from "./ModalAvertissement";

import { useToasts } from "react-toast-notifications";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
  MDBIcon,
} from "mdbreact";
import { Helmet } from "react-helmet";

const API_URL = process.env.REACT_APP_API_URL;

function FournisseurMontures() {
  const [show, setShow] = useState(false);
  const [fournisseur, setFournisseur] = useState([]);
  const { fournisseurId } = useParams();
  const [codeClient, setCodeClient] = useState();
  const [newCodeClient, setNewCodeClient] = useState();
  const [notes, setNotes] = useState();
  const [refresh, setRefresh] = useState(false);
  const [showAvertissement, setShowAvertissement] = useState(false);
  const type = 1;

  const history = useHistory();
  const dispatch = useDispatch();
  const { addToast } = useToasts();

  const TOKEN_KEY = "jwt";
  const token = localStorage.getItem(TOKEN_KEY);
  const loggedIn = useSelector((state) => state.login);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleShowAvertissement = () => setShowAvertissement(true);

  const getFournisseur = () =>
    axios.get(`${API_URL}/api/fournisseurs/${fournisseurId}`);
  const getNotes = () =>
    axios.get(`${API_URL}/api/notes/${type}/${fournisseurId}`, {
      headers: { authorization: `Bearer ${token}` },
    });

  useEffect(() => {
    function getFournisseurAndNotes() {
      axios
        .all([getFournisseur(), loggedIn ? getNotes() : null])
        .then((res) => {
          setFournisseur(res[0].data);
          if (loggedIn && res[1].data.notes) {
            setNotes(res[1].data.notes);
          }
          if (loggedIn) {
            setCodeClient(res[1].data.code_client);
          }
        })
        .catch((e) => {
          if (e.response.status === 401) {
            addToast("Votre session est expirée. Merci de vous reconnecter.", {
              appearance: "warning",
              autoDismiss: true,
            });
            logOut();
            dispatch({ type: "LOGOUT" });
            history.push("/login");
          } else {
            addToast(`Erreur : ${e.message}`, {
              appearance: "error",
              autoDismiss: true,
            });
          }
        });
    }

    getFournisseurAndNotes();
  }, [refresh]);

  const handleChangeCodeClient = (e) => {
    const { value } = e.target;
    setNewCodeClient(() => value);
  };

  function handleSubmit() {
    const newNote = notes;
    axios
      .put(
        `${API_URL}/api/notes/fournisseur/${fournisseurId}`,
        { newNote, type, newCodeClient },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        addToast("Mise à jour effectuée !", {
          appearance: "success",
          autoDismiss: true,
        });
        setRefresh(!refresh);
      })
      .catch((e) => {
        console.error(e);
        addToast(`Erreur : ${e.message}`, {
          appearance: "error",
          autoDismiss: true,
        });
      });
  }

  return (
    <div className="fournisseurMain">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{fournisseur.nom}</title>
      </Helmet>
      <a
        href={fournisseur.site_internet ? fournisseur.site_internet : null}
        target="_blank"
        rel="noreferrer"
        className="fournisseurTitleSpan"
      >
        <span>
          {fournisseur.id ? (
            <img
              src={`${API_URL}/images/fournisseurs-montures/${fournisseur.id}.png`}
              alt="Logo"
              className="fournisseurLogo"
            />
          ) : (
            "Loading"
          )}
          <h1>
            {fournisseur.nom
              ? `${fournisseur.nom
                  .charAt(0)
                  .toUpperCase()}${fournisseur.nom.slice(1)}`
              : null}
          </h1>
        </span>
      </a>
      <h2>Contact</h2>
      <span className="contactFirstLine">{fournisseur.nom}</span>
      <br />
      {fournisseur.adresse_rue_1}
      <br />
      {fournisseur.adresse_rue_2}
      {fournisseur.adresse_rue_2 ? <br /> : null}
      {fournisseur.adresse_code_postal} {fournisseur.adresse_ville}
      <br />
      {fournisseur.adresse_pays}
      {fournisseur.adresse_pays ? <br /> : null}
      <br />
      <MDBIcon icon="globe" />{" "}
      {fournisseur.site_internet ? (
        <a href={fournisseur.site_internet} target="_blank" rel="noreferrer">
          Site internet
        </a>
      ) : null}
      <br />
      <MDBIcon icon="phone" /> {fournisseur.telephone}
      <br />
      {fournisseur.fax && (
        <div>
          <MDBIcon icon="fax" /> {fournisseur.fax}
          <br />
        </div>
      )}
      {fournisseur.email && (
        <div>
          <MDBIcon icon="envelope" />{" "}
          <a href={`mailto: ${fournisseur.email}`}> {fournisseur.email} </a>
          <br />
        </div>
      )}
      <b>Code client : </b>{" "}
      {codeClient ? (
        codeClient
      ) : (
        <i>Aucun code n'a été saisi pour le moment.</i>
      )}
      <button
        type="button"
        className="linkButton"
        onClick={loggedIn ? handleShow : handleShowAvertissement}
      >
        Modifier
      </button>
      <MDBContainer show={show} onHide={handleClose}>
        <MDBModal isOpen={show} toggle={handleClose}>
          <MDBModalHeader>Enregistrement du code client</MDBModalHeader>
          <MDBModalBody>
            <input className="modalInput" onChange={handleChangeCodeClient} />
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn type="button" outline color="primary" onClick={handleClose}>
              Fermer
            </MDBBtn>
            <MDBBtn
              type="button"
              color="primary"
              onClick={() => {
                handleSubmit();
                handleClose();
              }}
            >
              Ajouter
            </MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
      <h2 className="FournisseursH2">Mes représentants</h2>
      <Representant
        type={type}
        fournisseurId={fournisseurId}
        refresh={refresh}
        setRefresh={setRefresh}
      />
      <h2 className="FournisseursH2">Notes</h2>
      <SunEditor
        lang="fr"
        width="80%"
        height="auto"
        autoFocus={true}
        setContents={notes}
        disable={true}
        showToolbar={false}
        setOptions={{ showPathLabel: false, resizingBar: false }}
      />
      <NotesFournisseur
        notes={notes}
        setNotes={setNotes}
        fournisseurId={fournisseurId}
        refresh={refresh}
        setRefresh={setRefresh}
        codeClient={codeClient}
        type={type}
      />
      <ModalAvertissement
        showAvertissement={showAvertissement}
        setShowAvertissement={setShowAvertissement}
      />
    </div>
  );
}

export default FournisseurMontures;
